import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/apps/")({
  beforeLoad: () => {
    throw redirect({ to: "/apps/app-library" });
  },
});
